import React from "react";
import { useParams } from "react-router-dom";
import ProductsContainer from "../components/ProductsContainer";

const Category = () => {
  const { categoryId, subcategoryId, subsub } = useParams();

  return (
    <>
      <ProductsContainer
        categoryId={categoryId}
        subcategoryId={subcategoryId}
        subsub={subsub}
      />
    </>
  );
};

export default Category;
